import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { useThemeForRoute } from '@/theme/useTheme';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
});

function Root() {
  // Light, dark or system — and always light in the portal (src/theme).
  useThemeForRoute();
  return <Outlet />;
}
